var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { flatten, map, pluck } from "ramda";
import { Maybe } from "true-myth";
import { getItemTotals } from "helpers/online_ordering/item_totals";
export function transformCartItem(cartItem) {
    var subtotal = getItemTotals(cartItem).subtotal;
    var id = cartItem.id, name = cartItem.name, price = cartItem.price, quantity = cartItem.quantity, instructions = cartItem.instructions, selectedModifiers = cartItem.selectedModifiers, selectedSides = cartItem.selectedSides;
    return {
        itemId: id,
        name: name,
        price: price,
        quantity: quantity,
        instructions: instructions,
        total: Math.round(subtotal),
        modifiers: flatten(pluck("mods", selectedModifiers)),
        sides: selectedSides,
    };
}
export function convertStockLevelToMaybe(serializedCart) {
    return map(function (item) {
        var sidesWithStocks = map(function (side) {
            return __assign(__assign({}, side), { stockLevel: Maybe.of(side.stockLevel.value) });
        }, item.sides);
        var selectedSidesWithStocks = map(function (side) {
            return __assign(__assign({}, side), { stockLevel: Maybe.of(side.stockLevel.value) });
        }, item.selectedSides);
        return __assign(__assign({}, item), { sides: sidesWithStocks, selectedSides: selectedSidesWithStocks, stockLevel: Maybe.of(item.stockLevel.value) });
    }, serializedCart);
}
